import axios from "../axiosInstance";

class PreRegisteredService {
  async listPreRegisteredItems() {
    return await axios.get("preregister");
  }
}

export default new PreRegisteredService();
